import { makeAutoObservable } from 'mobx';
import { validateUnderlyingBreakPrice } from './validateUnderlyingBreakPrice';

export class UnderlyingBreakPriceData {
  prices = [];
  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }
  resetToDefaults = () => {
    this.prices = [];
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateUnderlyingBreakPrice(this.prices);
    return result;
  };
  returnJson = () => {
    return {
      prices: this.prices,
    };
  };

  //specific methods
  addPrice = (number) => {
    this.prices.push(number);
  };
  removePrice = (index) => {
    const newArr = this.prices.filter((_, i) => i !== index);
    this.prices = newArr;
  };
  clearPrices = () => {
    this.prices = [];
  };
}
